import type { TermLine } from '../../hooks/useTypewriter.js';
import { useTypewriter } from '../../hooks/useTypewriter.js';

function variantClass(variant: TermLine['variant']): string {
  switch (variant) {
    case 'ok':
      return 'term-line--ok';
    case 'error':
      return 'term-line--error';
    case 'amber':
      return 'term-line--amber';
    case 'system':
      return 'term-line--system';
    default:
      return '';
  }
}

export function TerminalLines({
  lines,
  animationsEnabled,
  onDone,
  onLineComplete,
  showCursorAtEnd = true,
}: {
  lines: TermLine[];
  animationsEnabled: boolean;
  onDone?: () => void;
  onLineComplete?: (line: TermLine) => void;
  showCursorAtEnd?: boolean;
}) {
  const { completed, typing, done } = useTypewriter(lines, animationsEnabled, onDone, onLineComplete);

  return (
    <div className="term-text" aria-live="polite">
      {completed.map((line) => (
        <div key={line.id} className={`term-line ${variantClass(line.variant)}`}>
          {line.text}
        </div>
      ))}
      {typing && (
        <div className={`term-line ${variantClass(typing.line.variant)}`}>
          {typing.line.text ? typing.revealed : ' '}
          <span className="term-cursor" aria-hidden="true" />
        </div>
      )}
      {done && showCursorAtEnd && (
        <div className="term-line">
          <span className="term-cursor" aria-hidden="true" />
        </div>
      )}
    </div>
  );
}
